import React, { useState, useEffect } from 'react';
import './App.css';
import Registration from './Registration';
import QuickAccess from './QuickAccess';

function App() {
  const [showRegistration, setShowRegistration] = useState(false);
  const [showQuickAccess, setShowQuickAccess] = useState(false);
  const [inviteCodeFromUrl, setInviteCodeFromUrl] = useState(null);

  // Check for invite code in URL and guest access
  useEffect(() => {
    // Check if user has guest access (logged in with access code that allows without registration)
    const guestAccess = sessionStorage.getItem('guest_access');
    const chatAuthToken = localStorage.getItem('chat_auth_token');
    
    // If user has guest access or is logged in, redirect to dashboard
    if (guestAccess === 'true' || chatAuthToken) {
      window.location.href = '/dashboard';
      return;
    }

    // Check for invite code in URL
    const urlParams = new URLSearchParams(window.location.search);
    const invite = urlParams.get('invite');
    const register = urlParams.get('register');
    const code = urlParams.get('code');
    
    if (invite) {
      setInviteCodeFromUrl(invite.toUpperCase());
      setShowRegistration(true);
    } else if (register === 'true' && code) {
      setInviteCodeFromUrl(code.toUpperCase());
      setShowRegistration(true);
    }
  }, []);

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1 className="title">Welcome to Papita.org</h1>
          <p className="subtitle">Access premium products and services</p>
        </header>
        
        <div className="main-content">
          <div className="intro-card">
            <h2>Papita Products</h2>
            <p>Register to access our suite of premium products and services. Join our community and unlock exclusive features.</p>
          </div>

          <section className="quick-access-section">
            <div className="quick-access-card">
              <h2 className="quick-access-title">Already Registered or Have a Quick Access Code?</h2>
              <p className="quick-access-description">
                Log in with your credentials or use a quick access code to get started immediately.
              </p>
              <button 
                onClick={() => setShowQuickAccess(true)}
                className="quick-access-button"
              >
                Quick Access
              </button>
            </div>
          </section>

          <section className="registration-section">
            <div className="registration-card">
              <h2 className="registration-title">Register to Use Papita Products</h2>
              <p className="registration-description">
                Create your account to get started. Registration requires a valid access code.
              </p>
              <button 
                onClick={() => setShowRegistration(true)}
                className="register-button"
              >
                Register Now
              </button>
            </div>
          </section>
        </div>

        <footer className="footer">
          <p>© 2024 Papita.org - Built with React & Node.js</p>
        </footer>
      </div>

      {showQuickAccess && (
        <QuickAccess
          onClose={() => {
            setShowQuickAccess(false);
          }}
        />
      )}

      {showRegistration && (
        <Registration
          inviteCode={inviteCodeFromUrl}
          onRegistered={() => {
            setShowRegistration(false);
            setInviteCodeFromUrl(null);
            // Clear URL parameter
            window.history.replaceState({}, document.title, window.location.pathname);
          }}
          onCancel={() => {
            setShowRegistration(false);
            setInviteCodeFromUrl(null);
            // Clear URL parameter
            window.history.replaceState({}, document.title, window.location.pathname);
          }}
        />
      )}
    </div>
  );
}

export default App;
